import { MOVE_TO_COFEE_OPTIONS, MoveToCofeeAction } from './constants';

interface ChooseActionStepProps {
  selectedAction: MoveToCofeeAction | null;
  onSelectAction: (action: MoveToCofeeAction) => void;
}

const ChooseActionStep = ({
  selectedAction,
  onSelectAction
}: ChooseActionStepProps) => (
  <div className="flex flex-col gap-4">
    <p className="text-sm text-cofeeNeutral7">
      What would you like to do with this lead?
    </p>
    {MOVE_TO_COFEE_OPTIONS.map((option) => {
      const isSelected = selectedAction === option.id;
      return (
        <button
          key={option.id}
          type="button"
          onClick={() => onSelectAction(option.id)}
          className={`flex justify-between gap-4 rounded-xl border p-3 text-left ${
            isSelected
              ? 'border-cofeePrimary6 bg-cofeePrimary1'
              : 'border-grey30 bg-white'
          }`}
        >
          <div className="flex flex-col gap-2">
            <span className="text-sm font-semibold text-cofeeNeutral10">
              {option.label}
            </span>
            <span className="text-sm text-cofeeNeutral7">
              {option.description}
            </span>
          </div>
          <div className="flex pt-1">
            <div
              className={`flex size-4 shrink-0 items-center justify-center rounded-full border ${
                isSelected ? 'border-cofeePrimary6' : 'border-cofeeNeutral8'
              }`}
            >
              {isSelected && (
                <div className="size-2 rounded-full bg-cofeePrimary5" />
              )}
            </div>
          </div>
        </button>
      );
    })}
  </div>
);

export default ChooseActionStep;
